import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Cursor from './Cursor';
import './Cursor.css';

export default function Layout(){
  const { pathname } = useLocation();
  useEffect(()=>{ window.scrollTo(0,0); },[pathname]);
  return(<>
    <Cursor/>
    <Navbar/>
    <main><Outlet/></main>
    <Footer/>
  </>);
}